var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrNoti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3675_4077)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 63C52.1208 63 66 49.1208 66 32C66 14.8792 52.1208 1 35 1C17.8792 1 4 14.8792 4 32C4 49.1208 17.8792 63 35 63Z",
    fill: "#F44336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66557 32.6656C4.66557 15.5436 18.5436 1.66557 35.6656 1.66557C44.0572 1.66557 51.6662 4.99942 57.2486 10.4169C51.6153 4.60967 43.7304 1 35 1C17.8792 1 4 14.8792 4 32C4 40.7304 7.60967 48.6153 13.4169 54.2486C8.00242 48.6662 4.66557 41.0572 4.66557 32.6656Z",
    fill: "#E57373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7386 46.9064L37.0991 62.9191C52.665 61.8757 65.083 49.3528 65.9495 33.7389L49.604 17.3934L20.7386 46.9064Z",
    fill: "url(#paint0_linear_3675_4077)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1211 47.7338C22.1347 47.7338 21.1484 47.356 20.3959 46.6035C18.8908 45.0985 18.8908 42.6581 20.3959 41.153L44.1525 17.3963C45.6576 15.8913 48.098 15.8913 49.603 17.3963C51.108 18.9014 51.108 21.3418 49.603 22.8468L25.8463 46.6035C25.0938 47.356 24.1075 47.7338 23.1211 47.7338Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8778 47.7338C45.8914 47.7338 44.905 47.356 44.1525 46.6035L20.3959 22.8468C18.8908 21.3418 18.8908 18.9014 20.3959 17.3963C21.9009 15.8913 24.3413 15.8913 25.8463 17.3963L49.603 41.153C51.108 42.6581 51.108 45.0985 49.603 46.6035C48.8505 47.356 47.8641 47.7338 46.8778 47.7338Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3675_4077",
    x: 0,
    y: 0,
    width: 70,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3675_4077"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3675_4077",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3675_4077",
    x1: 31.4569,
    y1: 28.4368,
    x2: 56.9687,
    y2: 53.9486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B71C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F44336"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrNoti);
export default __webpack_public_path__ + "static/media/err-noti.c8d47a3d62816eaa09936b7445d73675.svg";
export { ForwardRef as ReactComponent };